import { TTgbNativedescGeneralContext } from '@cian/adfox-templates';

import { FC } from 'react';
import { useSelector } from 'react-redux';

import { jsonQueryFromResultsSelector } from '../../../../../../selectors/getJsonQuery';
import { useAdfoxContext } from '../../../external/context/AdfoxContext';

import { TgbNativedescGeneral, TgbNativedescGeneralProps } from './TgbNativedescGeneral';
import { useNewbuidingInfoForTgb } from './internal/hooks/useNewbuidingInfoForTgb';
import { jsonRegionIdToTransportType } from './internal/utils/jsonRegionIdToTransportType';

type TgbNativedescGeneralContainerProps = {
  context: TTgbNativedescGeneralContext;
};

export const TgbNativedescGeneralContainer: FC<TgbNativedescGeneralContainerProps> = props => {
  const { context } = props;

  const {
    annotation,
    image,
    url,
    metroDistance,
    metroColor,
    metro,
    description,
    title,
    location,
    button,
    label,
    logoImageUrl,
    builderName,
    mortgageTermsWarning,
    mortgageWarning,
  } = context;

  const newbuidingInfoForTgb = useNewbuidingInfoForTgb(context);

  const jsonQuery = useSelector(jsonQueryFromResultsSelector);

  const { sizes } = useAdfoxContext();

  const tgbNativedescGeneralProps = ((): TgbNativedescGeneralProps => {
    const transports: TgbNativedescGeneralProps['transports'] = [];

    if (metro) {
      const iconType = jsonRegionIdToTransportType(jsonQuery);

      transports.push({
        iconColor: metroColor,
        iconType,
        id: 1,
        name: metro,
        remoteness: metroDistance,
      });
    }

    const result: TgbNativedescGeneralProps = {
      logoImageUrl,
      url,
      transports,
      label,
      button,
      image,
      annotation,
      builderName,
      title,
      address: location,
      description,
      mortgageTermsWarning,
      mortgageWarning,
      sizes,
    };

    if (newbuidingInfoForTgb) {
      Object.assign<TgbNativedescGeneralProps, Partial<TgbNativedescGeneralProps>>(result, {
        logoImageUrl: newbuidingInfoForTgb.publisher.logo.url,
        transports: newbuidingInfoForTgb.transports,
        builderName: newbuidingInfoForTgb.publisher.name,
        address: newbuidingInfoForTgb.address,
      });
    }

    return result;
  })();

  return <TgbNativedescGeneral {...tgbNativedescGeneralProps} />;
};
